import { useNavigate } from "react-router-dom";
import Warning from "@/assets/images/warning.png";
import { Button, Container, Typography } from "@/components/atoms";
import { GeneralFooter, GeneralHeader } from "@/components/organisms";

export interface ExpiredProps {
  title?: string;
  description?: string;
}

export const Expired = ({ title = "Expired", description = "" }: ExpiredProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-row overflow-hidden">
      <div className="relative flex flex-1 flex-col">
        <GeneralHeader />
        <Container className="flex w-full max-w-[1040px] flex-1 justify-center gap-5 px-5 py-8 md:py-[100px]">
          <div className="flex max-w-[450px] flex-col items-center">
            <img src={Warning} alt="Warning" className="max-w-[128px]" />
            <Typography variant="h1" className="mb-4 text-center">
              {title}
            </Typography>
            <Typography variant="paragraph" className="text-center text-neutral-dark-gray">
              {description}
            </Typography>
            <Button size="lg" onClick={() => navigate("/forgot-password")} className="mt-8">
              Go Back
            </Button>
          </div>
        </Container>
        <div className="pointer-events-none fixed bottom-0 min-h-[50%] w-full bg-city bg-cover bg-no-repeat" />
        <GeneralFooter />
      </div>
    </div>
  );
};
